import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
const StyledMobilePanelBody = styled.div.withConfig({
  displayName: "MobilePanelBody__StyledMobilePanelBody",
  componentId: "sc-154o7rg-0"
})(["min-height:auto;overflow:auto;padding:0;position:relative;"]);
StyledMobilePanelBody.displayName = 'StyledMobilePanelBody';

function MobilePanelBody(_ref, ref) {
  let {
    children,
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  return /*#__PURE__*/_jsx(StyledMobilePanelBody, Object.assign({}, rest, {
    className: className,
    ref: ref,
    children: children
  }));
}

const MobilePanelBodyWrapper = /*#__PURE__*/forwardRef(MobilePanelBody);
export default MobilePanelBodyWrapper;